export function isEmpty(value) {
  return value == null || value === '' || value !== value;
}
